import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import './main.less';

const propTypes = {
	icon: PropTypes.string,
	notifications: PropTypes.string,
	isActive: PropTypes.bool,
	children: PropTypes.element
};

class Subitem extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		const { icon, notifications, children, isActive } = this.props;
		return (<div className={cn(
			'main-menu__subitem',
			icon && `main-menu__subitem--${icon}`,
			isActive && 'main-menu__subitem--active'
		)}>
			{children}
			{notifications && <div className="main-menu__subitem-notification">{notifications}</div>}
		</div>);
	}
}

Subitem.propTypes = propTypes;

export default Subitem;




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/sidebar/components/menu/subitem/main.js